import { render, staticRenderFns } from "./income-by-field.vue?vue&type=template&id=e810e7d6"
import script from "./income-by-field.vue?vue&type=script&lang=js"
export * from "./income-by-field.vue?vue&type=script&lang=js"
import style0 from "./income-by-field.vue?vue&type=style&index=0&id=e810e7d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports